(function () {
  'use strict';

  // only one touch supported for swipe events
  var thresholdForSwipe = 30;
  var passedThreshold = false;
  var startState = null;

  $(document).on('touchstart', '[data-swipe]', function (e) {
    if (!e.touches) {
      return;
    }

    if (e.touches.length !== 1) {
      if (passedThreshold) {
        var swipeEvent = $.Event('swipeend', {
          deltaX: e.touches[0].pageX - startState.pageX
        });
        startState.$target.trigger(swipeEvent);
      }

      passedThreshold = false;
      startState = null;
      return;
    }

    startState = {
      $target: $(this),
      pageX: e.touches[0].pageX
    };
  })
  .on('touchmove', '[data-swipe]', function (e) {
    if (!startState || !e.touches || e.touches.length !== 1) {
      return;
    }

    var deltaX = e.touches[0].pageX - startState.pageX;
    if (!passedThreshold && Math.abs(deltaX) < thresholdForSwipe) {
      return;
    }

    passedThreshold = true;
    var swipeEvent = $.Event('swipemove', {
      deltaX: deltaX
    });

    startState.$target.trigger(swipeEvent);
  })
  .on('touchend', '[data-swipe]', function (e) {
    if (!startState || !e.changedTouches || e.changedTouches.length !== 1) {
      return;
    }

    var deltaX = e.changedTouches[0].pageX - startState.pageX;
    if (!passedThreshold && Math.abs(deltaX) < thresholdForSwipe) {
      return;
    }

    var swipeEvent = $.Event('swipeend', {
      deltaX: deltaX
    });

    startState.$target.trigger(swipeEvent);
    passedThreshold = false;
    startState = null;
  });

}());
